import { Box, IconButton, styled, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Control, useForm } from 'react-hook-form';
import { CompoundInput } from '../../forms/CompoundInput';
import { Mic } from '@mui/icons-material';

const PREFIX = 'MessageInput';

const componentClasses = {
  wrapper: `${PREFIX}-wrapper`,
  input: `${PREFIX}-input`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${componentClasses.wrapper}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    // border: `1px dotted ${theme.palette.divider}`,
  },
}));

export interface MessageInputProps {
  control: Control<any>;
  onSubmit: () => void;
}

const MessageInput = ({ control, onSubmit }: MessageInputProps) => {
  const { t } = useTranslation();

  return (
    <StyledBox className={componentClasses.wrapper}>
      <CompoundInput
        name="question"
        control={control}
        required={true}
        placeholder={t('aiServices.inputPlaceholder')}
        onSubmit={onSubmit}>
        {/* <Box>
          <IconButton>
            <Mic />
          </IconButton>
        </Box> */}
      </CompoundInput>
    </StyledBox>
  );
};

export { MessageInput };
